// extracted by mini-css-extract-plugin
export default {"bubble":"yb8QE9hZzmDdBtrjtsUQ-ResultFilterBubble-bubble","bubblePrimaryOnly":"XqTScLBEjGlHG2ZlDH6E-ResultFilterBubble-bubblePrimaryOnly"};